import { useRef, useState } from 'react';
const verifyUrlFromLocation = () => {
    const { pathname, search } = window.location;
    const invoicePath = pathname
        .replace(/\/pay\/(success|cancel|error)\/([^/]+)\/?$/, '/$2')
        .replace(/\/view\/?$/, '');
    const query = new URLSearchParams(search);
    if (query.has('password')) {
        query.delete('password');
        const cleanSearch = query.toString() ? `?${query}` : '';
        window.history.replaceState(window.history.state, '', `${pathname}${cleanSearch}${window.location.hash}`);
        return `${invoicePath}/verify-password${cleanSearch}`;
    }
    return `${invoicePath}/verify-password${search}`;
};
export const useVerifyPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const inFlight = useRef(false);
    const clearError = () => setError(null);
    const verify = async (password) => {
        if (!password || inFlight.current) {
            return;
        }
        inFlight.current = true;
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(verifyUrlFromLocation(), {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            if (res.ok) {
                window.location.reload();
                return;
            }
            if (res.status === 401) {
                setError('INVALID_PASSWORD');
            }
            else if (res.status === 429) {
                setError('TOO_MANY_ATTEMPTS');
            }
            else {
                setError('UNKNOWN');
            }
        }
        catch {
            setError('UNKNOWN');
        }
        setLoading(false);
        inFlight.current = false;
    };
    return { loading, error, verify, clearError };
};
//# sourceMappingURL=useVerifyPassword.js.map